import { DiagnosticsPanel } from '@ms/yammer-diagnostics-panel';
import { useTranslations } from '@ms/yammer-i18n-react';
import SuiteHeaderStrings from '@ms/yammer-strings/dist/SuiteHeader';
import { WrenchScrewdriver20Regular } from '@ms/yammer-web-core-ui/dist/components/FluentUISystemIcon';
import { useRenderToggleableContent } from '@ms/yammer-web-core-ui/dist/util/useRenderToggleableContent';
import React, { useMemo } from 'react';

import type { VivaEngageNavigationHeaderMenuButtonItemWithContent } from '../types';

type UseDiagnosticsPanelMenuButtonItem = () => VivaEngageNavigationHeaderMenuButtonItemWithContent;
export const useDiagnosticsPanelMenuButtonItem: UseDiagnosticsPanelMenuButtonItem = () => {
  const t = useTranslations(SuiteHeaderStrings);

  const { showContent: showPanel, content: diagnosticsPanel } = useRenderToggleableContent(({ hideContent }) => (
    <DiagnosticsPanel onClosePanel={hideContent} />
  ));

  return useMemo(
    () => ({
      item: {
        key: 'diagnostics',
        text: t.diagnosticsButtonAriaLabel(),
        icon: WrenchScrewdriver20Regular,
        onClick: showPanel,
      },
      content: diagnosticsPanel,
    }),
    [showPanel, t, diagnosticsPanel]
  );
};
